import { render, staticRenderFns } from "./ArgMana.vue?vue&type=template&id=65f239f4&scoped=true&"
import script from "./ArgMana.vue?vue&type=script&lang=js&"
export * from "./ArgMana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f239f4",
  null
  
)

export default component.exports